module.exports = __webpack_public_path__ + "img/login.9017ddd9.png";